var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCameraAvatar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.45,
    width: 40,
    height: 40,
    rx: 8,
    fill: "#6371E0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.6667 19V14.3333C26.6667 13.6 26.0667 13 25.3333 13H9.33333C8.6 13 8 13.6 8 14.3333V27.6667C8 28.4 8.6 29 9.33333 29H25.3333C26.0667 29 26.6667 28.4 26.6667 27.6667V23L29.72 26.0533C30.56 26.8933 32 26.2933 32 25.1067V16.88C32 15.6933 30.56 15.0933 29.72 15.9333L26.6667 19ZM18.28 24.0533C18.1566 24.1769 18.0101 24.275 17.8488 24.3419C17.6875 24.4088 17.5146 24.4433 17.34 24.4433C17.1654 24.4433 16.9925 24.4088 16.8312 24.3419C16.6699 24.275 16.5234 24.1769 16.4 24.0533L12.16 19.8133V23.2133H10.6667V17.96C10.6667 17.5867 10.96 17.2933 11.3333 17.2933H16.5867V18.7733H13.1867L17.3333 22.9067L22.96 17.28L24 18.3333L18.28 24.0533Z",
    fill: "#6371E0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraAvatar);
export default __webpack_public_path__ + "static/media/camera-avatar.0a85cacdfdefd57bd46255e2b2517849.svg";
export { ForwardRef as ReactComponent };